import { StyleProps } from '$/components/ui';
import {
  AttendeeFragment,
  InteractionForAttendeeFragment,
  InteractionFragment,
  PublicEWebinarFragment,
} from '$/GraphQL/schema/types';
import { HandoutIcon } from '$/images/FontAwesomeIcons';
import { yupIsValidUrl } from '$/utils/isUrl';
import React from 'react';
import * as yup from 'yup';
import { AnalyticsCardProps } from '../cards/types';
import { InteractionInfo } from '../InteractionInfo';
import {
  InteractionModalAccordionsHook,
  InteractionModalComponentProps,
  ModalValidationRules,
} from '../types';
import { HandOutCard } from './HandoutCard';
import { HandoutSettings } from './HandoutSettings';

const AnalyticsHandoutCard = React.lazy(() => import('./AnalyticsHandoutCard'));
const HandoutModal = React.lazy(() => import('./HandoutModal'));

export class HandoutInfo extends InteractionInfo {
  public constructor(
    i: InteractionForAttendeeFragment | InteractionFragment,
    ewebinar?: PublicEWebinarFragment,
    attendee?: AttendeeFragment
  ) {
    super(i, ewebinar, attendee);
  }

  public category(): 'Standard' | 'Special' | 'Anchor' | 'Conversion' {
    return 'Standard';
  }

  public hasAnswers(): boolean {
    return true;
  }

  public modalValidationRules(): ModalValidationRules {
    return {
      ...super.modalValidationRules(),

      link: yupIsValidUrl().required(),
      buttonText: yup.string().trim().required(),
    };
  }

  public icon(): React.FC<StyleProps> {
    return HandoutIcon;
  }

  public useModalPreviewComponent(): React.LazyExoticComponent<
    React.FC<InteractionModalComponentProps>
  > | null {
    return HandoutModal;
  }

  public modalSettingsAccordions(): InteractionModalAccordionsHook | null {
    return HandoutSettings;
  }

  public analyticsCardComponent(): React.LazyExoticComponent<React.FC<AnalyticsCardProps>> {
    return AnalyticsHandoutCard;
  }

  public cardBodyComponent(): React.FC {
    return HandOutCard;
  }

  public canSubmitMuktipleTimes(): boolean {
    return true;
  }
}
